import template from './invoiceModal.html';
import './invoiceModal.scss';

let component = {
	bindings: {
		modal: '=',
		selection: '='
	},
	template,
	controller: function(
		$cordovaBarcodeScanner,
		$ionicLoading,
		$ionicScrollDelegate,
		$q,
		$scope,
		$timeout,
		$window,
		_,
		Basket,
		growl,
		Invoice,
		Language,
	) {
		"ngInject"

		const vm = this;

		var lookup;

		vm.steps = [
			'invoice_type'
		];

		vm.history = Invoice.get();
		if (vm.history) {
			vm.history = _.uniq(vm.history.map(invoice => {
				return {
					gender: invoice.gender,
					company: invoice.company,
					firstname: invoice.firstname,
					lastname: invoice.lastname,
					phone: invoice.phone,
					email: invoice.email,
					birthdate: invoice.birthdate ? new Date(invoice.birthdate) : undefined,
					city: invoice.city,
					street: invoice.street,
					zipcode: invoice.zipcode,
					housenumber: invoice.housenumber,
					suffix: invoice.suffix,
					country: invoice.country
				};
			}));
		}
		

		vm.data = {};
		vm.data.country = 'NL';
		vm.data.gender = 'm';
		vm.hasGu = false;
		
		vm.step = 'invoice_type';

		vm.prefill = (history) => {
			_.forEach(history, (value, key) => {
				vm.data[key] = value;
			});
		}

		vm.transformDownPayment = () => {
			var lan = Language.get();
			if (lan === 'nl') {
				var r = parseFloat(vm.downPayment.input.split('.').join('').split(',').join('.'));
			}
			if (lan === 'en') {
				var r = parseFloat(vm.downPayment.input.split(',').join(''));
			}
			if (!r) {
				r = 0;
			}
			vm.downPayment.price = r;
		}

		vm.setDownPayment = (type, price) => {
			vm.downPayment.type = type;
			vm.downPayment.price = price;
		}

		vm.check = {
			gender: function() {
				return !vm.data.method || vm.data.method !== 'reserve' || (vm.data.gender && vm.data.gender.length > 0);
			},
			firstname: function() {
				return !vm.data.method || vm.data.method !== 'reserve' || (vm.data.firstname && vm.data.firstname.length > 0);
			},
			lastname: function() {
				return !vm.data.method || vm.data.method !== 'reserve' || (vm.data.lastname && vm.data.lastname.length > 0);
			},
			phone: function() {
				return !vm.data.method || vm.data.method !== 'reserve' || (vm.data.phone && vm.data.phone.length > 0);
			},
			email: function() {
				return !vm.data.method || vm.data.method !== 'online' || (vm.data.email && vm.data.email.length > 0);
			},
			company: function() {
				return true;
			},
			birthdate: function() {
				return true;
			},
			country: function() {
				return true;
			},
			zipcode: function() {
				return true;
			},
			housenumber: function() {
				return true;
			},
			suffix: function() {
				return true;
			},
			street: function() {
				return true;
			},
			city: function() {
				return true;
			},
			
		};

		vm.next = function() {
			var c;
			vm.steps.forEach(function(step, k) {
			    if (step === vm.step) {
			    	c = k;
			    }
			});
			c++;
			vm.step = vm.steps[c];
			vm.hasGu = vm.products.filter(item => item.gu).length > 0;
			$ionicScrollDelegate.scrollTop();
			$ionicScrollDelegate.resize();
		}

		vm.previous = function() {
			var c;
			vm.steps.forEach(function(step, k) {
			    if (step === vm.step) {
			    	c = k;
			    }
			});
			c--;
			vm.step = vm.steps[c];
			vm.hasGu = vm.products.filter(function(item) {
				return item.gu;
			}).length > 0;
			$ionicScrollDelegate.scrollTop();
			$ionicScrollDelegate.resize();
		}

		vm.disabled = function() {

			if (vm.step === 'invoice_type') {
				return !vm.data.method;
			}
			if (vm.step === 'product_information') {
				return !vm.products || vm.products.filter(product => product.errors && product.errors.length).length > 0;
			}
			if (vm.step === 'customer_details') {
				return _.reduce(vm.check, function(mem, f) {
					if (!f()) {
						mem++;
					}
					return mem;
				}, 0) > 0;
			}
			if (vm.step === 'customer_details') {
				return false;
			}
			if (vm.step === 'down_payment') {
				return !(vm.downPayment.price && vm.downPayment.price > 0 && vm.downPayment.price <= vm.total);
			}
			if (vm.step === 'extra_information') {
				return false;
			}
		}

		vm.serialNumber = (product) => {

			var update = function() {
				if (product.serial_number === null) {
					if (window.cordova === undefined) {
						var num = $window.prompt('Enter serial number');
						if (num != null) {
							return Basket.update(product.basket_id, {
								serial_number: num
							})
						} else {
							return $q.reject();
						}
					} else {
						return $cordovaBarcodeScanner.scan().then(function(result) {
							return Basket.update(product.basket_id, {
								serial_number: result.text
							});
						});
					}
				} else {
					return Basket.update(product.basket_id, {
						serial_number: null
					});
				}
			}

			update().then(validate);

		}

		vm.gu = (product) => {
			Basket.update(product.basket_id, {
				gu: product.gu
			}).catch(err => {
				growl.error($filter('translate')('growl_error_basket_update'));
				product.gu != product.gu;
			});
		}

		vm.kb = (product) => {
			Basket.update(product.basket_id, {
				kb: product.kb
			}).catch(err => {
				growl.error($filter('translate')('growl_error_basket_update'));
				product.kb != product.kb;
			});
		}

		vm.setMethod = (method) => {
			if (!vm.loading) {
				vm.data.method = method;
				vm.downPayment = {
					type: null,
					price: null,
					input: ''
				};
				if (vm.data.method === 'takeout') {
					vm.steps = [
						'invoice_type',
						'product_information',
						'customer_details',
						'address_details',
						'extra_information'
					];
				}
				if (vm.data.method === 'reserve') {
					vm.steps = [
						'invoice_type',
						'product_information',
						'customer_details',
						'address_details',
						'down_payment',
						'extra_information'
					];
				}
				if (vm.data.method === 'online') {
					vm.steps = [
						'invoice_type',
						'product_information',
						'customer_details',
						'address_details'
					];
				}
				validate().then(vm.next);
			}
		}

		// vm.incrementStep = () => {
		// 	if (!vm.loading) {
		// 		vm.stepIndex++;
		// 		vm.hasGu = vm.products.filter(function(item) {
		// 			return item.gu;
		// 		}).length > 0;
		// 		$ionicScrollDelegate.scrollTop();
		// 		$ionicScrollDelegate.resize();
		// 	}
		// }

		// vm.decreaseStep = () => {
		// 	if (!vm.loading) {
		// 		vm.stepIndex--;
		// 		$ionicScrollDelegate.scrollTop();
		// 		$ionicScrollDelegate.resize();
		// 	}
		// }

		vm.createInvoice = () => {
			if (!vm.loading) {
				var invoiceData = angular.copy(vm.data);
				invoiceData.products = vm.selection;
				invoiceData.payment = vm.downPayment.price;
				Invoice.create(invoiceData).then(res => {
					vm.modal.remove();
				}).catch(err => {
					console.log(err);
				});
			}
		}

		vm.lookup = function() {
			if (vm.data.country === 'NL') {
				if ((vm.data.zipcode && vm.data.zipcode.replace(' ', '').length === 6) && (vm.data.housenumber && vm.data.housenumber.length > 0)) {
					$timeout.cancel(lookup);
					lookup = $timeout(function() {
						Invoice.address({
							zipcode: vm.data.zipcode,
							number: vm.data.housenumber
						}).then(res => {
							vm.data.street = res.data.street;
							vm.data.city = res.data.municipality;
						}).catch(err => {
							
						});
					}, 500);
				} else {
					vm.data.street = '';
					vm.data.city = '';
				}
			}
		}

		function validate() {
			vm.loading = true;
			$ionicLoading.show();
			return Invoice.validate({
				method: vm.data.method,
				basket: vm.selection
			}).then(res => {
				vm.products = res.data;
				vm.total = _.reduce(vm.products, (mem, item) => {
					return mem+item.price.value;
				}, 0);
			}).catch(err => {
				console.log(err);
			}).finally(() => {
				vm.loading = false;
				$ionicLoading.hide();
			});
		}

		function randomizer() {
			var result = '';
			var options = [0, 1, 2, 3, 4, 5, 6, 7, 9, 9];
			for (var i = 0; i < 10; i++) {
				result += options[Math.round(Math.random()*9)];
			}
			return result;
		}
		
	}
};

export default component;



// WEBPACK FOOTER //
// ./app/components/invoiceModal/invoiceModal.component.js